import { generateClient } from "aws-amplify/api";
import { recievedSetUser, STUDENT_PROXY_LOGIN, STUDENT_PROXY_LOGOUT } from "../actions-index";
import { transformUser } from "../Authentication/transform";
import * as Queries from "../graphql/queries";
import { ACTION_STATUS, ERROR_TYPE, STORAGE_KEY_STUDENT_PROXY } from "../util/constants";
import { buildAction } from "../util/functions";

const API = generateClient();

export function loginAsStudentProxy(studentid) {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const user = state.authentication.user;
            if(user.isProxy === false) {
                dispatch(buildAction(STUDENT_PROXY_LOGIN, { status: ACTION_STATUS.LOADING }));
                const studentDetails = Object.freeze((((await API.graphql({ query: Queries.getUserDetails, variables: { studentid } }))?.data?.getUserDetails?.userDetails) ?? null));
                if(studentDetails === null) throw new Error("Student Not Found");
                const student = transformUser(studentDetails, user);
                dispatch(recievedSetUser(student));
                sessionStorage.setItem(STORAGE_KEY_STUDENT_PROXY, JSON.stringify(student));
                dispatch(buildAction(STUDENT_PROXY_LOGIN, { status: ACTION_STATUS.SUCCESS }));
            }
        } catch(error) {
            console.error("Login as Student Proxy Error: ", error);
            let message = null;
            const { errors = [] } = error;
            if(errors.length > 0) {
                const errorType = errors[0].errorType;
                if(errorType === ERROR_TYPE.NOT_FOUND) message = "The student does not have an active enrollment.";
                if(errorType === ERROR_TYPE.UNAUTHORIZED) message = "You lack sufficient security permissions to proxy as student.";
            }
            dispatch(buildAction(STUDENT_PROXY_LOGIN, { status: ACTION_STATUS.ERROR, message }));
        }
    };
}

export function logoutAsStudentProxy() {
    return async (dispatch, getState) => {
        try {
            dispatch(buildAction(STUDENT_PROXY_LOGOUT, { status: ACTION_STATUS.LOADING }));
            const state = getState();
            const user = state.authentication.user;
            dispatch(recievedSetUser(user.proxy));
            sessionStorage.removeItem(STORAGE_KEY_STUDENT_PROXY);
            dispatch(buildAction(STUDENT_PROXY_LOGOUT, { status: ACTION_STATUS.SUCCESS }));
        } catch(error) {
            console.error("Logout as Student Proxy Error: ", error);
            dispatch(buildAction(STUDENT_PROXY_LOGOUT, { status: ACTION_STATUS.ERROR }));
        }
    };
}